const mapper_options = {
  endpoint: 'reporting/pulse/brand_time_series',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('brand_time_series', mapper_options)
}